<template>
  <div class="row bg-white p-3 rounded">
    <div class="col-4 col-sm col-12 text-center text-md-left">
      <img
        src="@/assets/img/secretaria-auxiliar-logo.png"
        style="width: 200px"
      />
    </div>
    <div class="col col-sm col-12 d-flex justify-content-end mt-3 mt-md-0">
      <action-button
        class="warning px-4"
        :text="$t('RegisterMe')"
        iright="fa fa-user-circle"
        @click="$emit('on-register')"
      />
    </div>
  </div>
</template>

<script>
//component libs
import ActionButton from 'ActionButton';

export default {
  name: 'SignHeaderPanel',
  components: {
    ActionButton,
  },
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {},
};
</script>
